import Vue from 'vue';
import { error, mapState, mapMutations, mapActions } from '../store/helpers';
export default Vue.extend({
    computed: Object.assign({}, mapState(error, [
        'startTime',
        'endTime',
        'errorArray',
        'isRunning',
        'numberOfAttempts',
        'numberOfChars',
        'numberOfNonLetters',
        'responseData'
    ])),
    methods: Object.assign(Object.assign(Object.assign({}, mapMutations(error, [
        'errorLoggerStart',
        'errorLoggerStop',
        'incrementNumberOfAttempts',
        'resetErrorLogger',
        'setResponseData'
    ])), mapActions(error, ['logCorrectCharacter', 'logAnError'])), { logError(letterPressed, correctLetter, errCategory = 'Char') {
            this.logAnError({ letterPressed, correctLetter, errCategory });
        },
        getErrorLogger() {
            if (this.isRunning === true) {
                this.errorLoggerStop();
            }
            // @ts-ignore
            let duration = this.endTime - this.startTime;
            duration = Math.floor(duration / 1000);
            const errorReportObject = {
                duration,
                errors: this.errorArray,
                numberOfAttempts: this.numberOfAttempts,
                numberOfChars: this.numberOfChars,
                numberOfNonLetters: this.numberOfNonLetters,
                responseData: this.responseData
            };
            return errorReportObject;
        } })
});
